"use client";
import { useEffect } from "react";
import Image from "next/image";

import ForwardIcon from "@/assets/icons/forward-15.svg";
import PauseIcon from "@/assets/icons/pause.svg";
import PlayIcon from "@/assets/icons/play.svg";
import BackwardIcon from "@/assets/icons/replay-5.svg";
import { AudioSlider } from "@/components/partials";
import { useAudioContext } from "@/context";
import { BookDetailType } from "@/lib/schema";
import { apiAudio, apiImage } from "@/lib/utils";

export function AudioBookPlayer({ book }: { book: BookDetailType }) {
  const {
    isPlaying,
    currentTime,
    duration,
    togglePlayPause,
    handleForward,
    handleBackward,
    setAudio,
    formatTime,
    toggleAudioDrawer,
  } = useAudioContext();

  useEffect(() => {
    setAudio(
      {
        id: `BOOK.${book.id}`,
        src: apiAudio(book.audio!),
        thumbnail: book.banner,
        title: book.title,
      },
      false
    );

    return () => toggleAudioDrawer(true);
  }, []);

  return (
    <div className="sm:max-w-[295px] mx-auto pb-52 max-sm:mt-8">
      <figure
        itemProp="image"
        itemScope
        itemType="https://schema.org/ImageObject"
        className="rounded-xl w-[247px] max-sm:w-[200px] overflow-hidden aspect-square relative mx-auto mb-8 shadow-[0_0_32px_0_#00000029]"
      >
        <Image
          src={apiImage(book.banner, "medium")}
          fill
          alt=""
          itemProp="url"
          className="object-cover"
        />
        <meta itemProp="width" content="247" />
        <meta itemProp="height" content="247" />
      </figure>
      <h1 className="text-[#84807D] text-sm text-center">Цахим ном</h1>
      <h2 className="font-bold text-3xl mb-8 text-center">{book.title}</h2>
      <AudioSlider size="lg" />
      <div className="flex justify-between text-sm text-[#898480] mt-1 mb-8">
        <span>{formatTime(currentTime)}</span>
        <span>
          {currentTime >= duration ? "" : "-"}
          {formatTime((duration || 0) - currentTime)}
        </span>
      </div>

      <div className="flex items-center gap-6 justify-center mb-8">
        <button
          type="button"
          className="transition active:-rotate-45 active:scale-95"
          onClick={handleBackward}
        >
          <BackwardIcon style={{ width: 32, height: 32, color: "#84807D" }} />
        </button>
        <button
          type="button"
          className="transition active:scale-75 w-16 h-16 bg-primary flex items-center justify-center rounded-full"
          onClick={togglePlayPause}
        >
          {isPlaying ? (
            <PauseIcon style={{ width: 22, height: 22, color: "#fff" }} />
          ) : (
            <PlayIcon style={{ width: 18, height: 18, color: "#fff" }} />
          )}
        </button>
        <button
          type="button"
          className="transition active:rotate-45 active:scale-95"
          onClick={handleForward}
        >
          <ForwardIcon style={{ width: 32, height: 32, color: "#84807D" }} />
        </button>
      </div>
    </div>
  );
}
